import React, { useContext, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid, CircularProgress } from '@material-ui/core'
import Calculator from '../../components/Calculator'
/*import { auth } from '../../model/db/db'
import ErrorSnackbar from '../../components/ErrorSnackbar'
import LoginForm from '../../components/LoginForm'*/
import GroupCostBox from '../../components/GroupCostBox'
import { CalculatorContext } from '../../components/Context/CalculatorContext'
import Header from '../../components/Header'
import Summary from '../../components/Summary'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '100vh',
        padding: theme.spacing(2)
    },
    body: {
        maxWidth: 900,
        margin: 'auto'
    },
    grid: {
        margin: 'auto'
    },
    title: {
        display: 'flex',
        flexDirection: 'row',
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(1)
    },
    summary: {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(2)
    },
    logo: { marginRight: theme.spacing(2) },
    loadingScreen: {
        backgroundColor: theme.palette.background.paper,
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    loginScreen: { margin: 'auto', width: 400, padding: 300 }
}))

const App = () => {
    const [transactionCost, setTransactionCost] = useState({
        total: 0,
        blocks: {}
    })
    const [storageCost, setStorageCost] = useState({
        total: 0,
        sources: {},
        averageYearlyStorage: {}
    })
    const [masterDeliveryCost, setMasterDeliveryCost] = useState({
        total: 0,
        sources: {}
    })
    const [migrationCost, setMigrationCost] = useState(0)
    const [restoreCost, setRestoreCost] = useState(0)
    const [proxyRegenerationCost, setProxyRegenerationCost] = useState(0)

    /*const [error, setError] = useState(null)
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')*/

    const { /*user,*/ loading, error } = useContext(CalculatorContext)

    const classes = useStyles()

    const getTotalCost = () => {
        return {
            total:
                transactionCost.total +
                storageCost.total +
                masterDeliveryCost.total +
                restoreCost,
            sources: {
                ...Object.entries(transactionCost.blocks).reduce(
                    (acc, [key, { total }]) => {
                        acc[key] = total
                        return acc
                    },
                    {}
                ),
                Storage: storageCost.total,
                'Master Delivery': masterDeliveryCost.total,
                Restore: restoreCost
            }
        }
    }

    /*const authenticate = async () => {
        return await auth
            .signInWithEmailAndPassword(username, password)
            .catch((e) => e)
    }*/

    if (error) {
        return (
            <div className={classes.loadingScreen}>
                <Typography variant="h1" color="textPrimary">
                    {error}
                </Typography>
            </div>
        )
    }

    if (loading)
        return (
            <div className={classes.loadingScreen}>
                <CircularProgress size={200} data-testid="loadingSpinner" />
            </div>
        )

    /*if (!user) {
        return (
            <div className={classes.root}>
                <div className={classes.loginScreen}>
                    <LoginForm
                        setEmail={setUsername}
                        setPassword={setPassword}
                        authenticate={authenticate}
                    />
                    <ErrorSnackbar error={error} setError={setError} />
                </div>
            </div>
        )
    }*/

    return (
        <div className={classes.root}>
            <div className={classes.body}>
                <Header />

                <Grid container>
                    <Grid item xs={7}>
                        <Calculator
                            {...{
                                transactionCost,
                                setTransactionCost,
                                storageCost,
                                setStorageCost,
                                masterDeliveryCost,
                                setMasterDeliveryCost,
                                restoreCost,
                                setRestoreCost,
                                migrationCost,
                                setMigrationCost,
                                proxyRegenerationCost,
                                setProxyRegenerationCost
                            }}
                        />
                    </Grid>

                    <Grid item xs={5}>
                        <Summary
                            cost={getTotalCost()}
                            {...{ migrationCost, proxyRegenerationCost }}
                        />
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item xs={12}>
                        <Typography
                            style={{ marginLeft: 16 }}
                            variant="h2"
                            color={'textPrimary'}
                        >
                            Details
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <GroupCostBox
                            title="Transactions"
                            cost={transactionCost}
                            showDetails={true}
                            showSummary={false}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <GroupCostBox
                            title="Storage"
                            cost={storageCost}
                            showDetails={true}
                            showSummary={false}
                        />
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}

export default App
